import { MessageCircle } from "lucide-react";
import { useCountry } from "@/hooks/useCountry";
import { buildWhatsAppUrl } from "@/lib/whatsapp";

export function WhatsAppButton() {
  const { country, lang } = useCountry();
  const message = lang === "fr"
    ? "Bonjour, je souhaite prendre rendez-vous pour un test de vue gratuit."
    : "Hello, I would like to book a free eye test.";

  const url = buildWhatsAppUrl(country.whatsappNumber, message) ?? "#";

  const handleClick = () => {
    // Analytics — whatsapp_click (lazy import, no impact on first load)
    import("@/lib/analytics/track").then(({ track }) => {
      track("whatsapp_click", {
        whatsapp_context: "floating_button",
        country_slug: country.slug,
        prefilled_message_type: "eye_test",
      });
    }).catch(() => {});
  };

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="hidden md:fixed md:bottom-6 md:right-6 md:block z-40 bg-success text-success-foreground rounded-full p-3 shadow-lg hover:scale-105 transition-transform"
      aria-label="WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
